/* istanbul ignore file */
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Button } from 'framework/ui/mui-builder';
import { useListContext } from 'framework/list';
import { useNavigate } from 'react-router-dom';
import { useArtifactStorageUrl } from 'domain/shared/artifactStorage';

const ARTIFACT_STORAGE_BREADCRUMBS_SX = {
  '& .MuiBreadcrumbs-ol': {
    padding: 0,
    borderBottom: 0,
    marginTop: '20px',
    marginBottom: '10px',
  },
  '& .breadcrumb-item': {
    color: 'text.secondary',
    minWidth: '1px',
    textDecoration: 'none',
    fontWeight: 400,
  },
  '& .breadcrumb-item.active': {
    color: 'primary.main',
  },
  '& .breadcrumb-item + .breadcrumb-item': {
    paddingLeft: '8px !important',
  },
};

const ArtifactStorageBreadcrumbs = ({
  breadcrumbs: initialBreadcrumbs,
}: {
  breadcrumbs: { alias: string; name: string }[];
}) => {
  const { loading } = useListContext();
  const navigate = useNavigate();
  const { getListUrl } = useArtifactStorageUrl();
  const breadcrumbs = [...initialBreadcrumbs];

  if (!breadcrumbs.length || loading) {
    return null;
  }

  breadcrumbs.unshift({ alias: 'Root', name: 'Root' });

  return (
    <Breadcrumbs component="nav" sx={ARTIFACT_STORAGE_BREADCRUMBS_SX}>
      {breadcrumbs.map((breadcrumb, index) =>
        index === breadcrumbs.length - 1 ? (
          <span key={breadcrumb.alias} className="breadcrumb-item active">
            {breadcrumb.name || breadcrumb.alias}
          </span>
        ) : (
          <Button
            key={breadcrumb.alias}
            className="breadcrumb-item"
            onClick={(e: any) => {
              e.stopPropagation();

              const path = breadcrumbs.slice(1, index + 1).map(({ alias }) => alias);

              navigate(path.length ? `${getListUrl()}/${path.join('/').toLowerCase()}` : getListUrl());
            }}
            link
          >
            {breadcrumb.name || breadcrumb.alias}
          </Button>
        ),
      )}
    </Breadcrumbs>
  );
};

export default ArtifactStorageBreadcrumbs;
